import { Guid } from "@shared/utils/guid.helper";
import { SigningStatus } from "../annual-statements/annual-statement-enums";
import { EsignProvider } from "../integrations/esign-provider.enum";
import { DocumentBase } from "@models/documents/document-base";
import { Signature } from "./signature";
import { Approver, CarbonCopy } from "./sign-documents";

export class DocumentSigning {
    documentSigningId: string;
    approver?: Approver | null;
    carbonCopies?: CarbonCopy[];
    envelopeId: string | null;
    esignProvider: EsignProvider | null;
    documentId: string;
    document: DocumentBase;
    signedByPaper: boolean;
    signingStatus: SigningStatus;
    signatures: Signature[];
    createdOn: string;
    modifiedOn: string;
    useFullNameInEmailGreeting: boolean;
    signedOn: Date | null;

    constructor(data: Partial<DocumentSigning> = {}) {
        this.documentSigningId = data.documentSigningId ?? Guid.EmptyGuid;
        this.approver = data.approver ?? null;
        this.carbonCopies = data.carbonCopies ?? [];
        this.envelopeId = data.envelopeId ?? null;
        this.esignProvider = data.esignProvider ?? null;
        this.documentId = data.documentId ?? '';
        this.document = data.document ?? new DocumentBase();
        this.signedByPaper = data.signedByPaper ?? false;
        this.signingStatus = data.signingStatus ?? SigningStatus.ReadyToSend;
        this.signatures = (data.signatures ?? []).map((signature) => new Signature(signature));
        this.createdOn = data.createdOn ?? '';
        this.modifiedOn = data.modifiedOn ?? '';
        this.signedOn = data.signedOn ? new Date(data.signedOn) : null;
        this.useFullNameInEmailGreeting = data.useFullNameInEmailGreeting ?? false;
    }
}
